module.exports = __webpack_public_path__ + "media/images/clone_event_league-294dcf42.svg";